export const SCROLL_RESTORE_POSITION = 'SCROLL_RESTORE_POSITION';


export const getScrollPoint = (scrollPoint) => ({
  type: SCROLL_RESTORE_POSITION,
  data: { scrollPoint }
})
